<script setup lang="ts">
import { useCvButtonNavigation } from './useCvButtonNavigation';
import PillShapedSpan from 'theme/components/atoms/PillShapedSpan.vue';

const { cvButtonTo } = useCvButtonNavigation();
</script>

<template>
  <div :class="$style.container">
    <PillShapedSpan :class="[$style.balloon, $style.container__balloon]"
      >無料で</PillShapedSpan
    >
    <NuxtLink :to="cvButtonTo" :class="$style.button">
      <p :class="$style.button__heading">まずは診断をはじめる</p>
      <p :class="$style.button__subheading">診断後プロのアドバイスももらえる</p>
    </NuxtLink>
  </div>
</template>

<style module lang="scss">
.container {
  @include create-stacking-context;

  & {
    width: 360px;
    padding-top: -8px;
    position: relative;
  }

  &__balloon {
    display: inline-block;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 50%);
  }
}
.balloon {
  background-color: $color-okaneko-yellow;
  font-size: 16px;
  font-weight: 600;
  padding: 0 16px;
  position: relative;
  z-index: 1;
  &::after {
    background-color: $color-okaneko-yellow;
    content: '';
    width: 8px;
    height: 8px;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    z-index: 1;
  }
}
.button {
  width: 100%;
  padding: 20px 0 16px;

  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  background: linear-gradient(
    83deg,
    $color-surface-accent-orange 33.06%,
    #ffc412 98.07%
  );
  &:hover {
    opacity: 0.9;
  }
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.16);
  color: $color-text-and-object-high-emphasis-inverse;
  &__heading {
    font-size: 28px;
    font-weight: 900;
    line-height: 28px;
  }
  &__subheading {
    margin-top: 4px;
    font-size: 14px;
    line-height: 14px;
  }
}
</style>
